<template>
  <div class="purchase-container">
    <div class="fixed-wrapper">
      <div class="purchase-header">
        传统采购
      </div>
      <div class="search-row">
        <div class="material-name">
          <span>物料名称/编码</span>
          <el-input
            placeholder="请输入物料名称或物料编码"
            v-model="material"
            clearable
            size="mini"
          ></el-input>
        </div>
        <div class="purchase-order">
          <span>采购订单</span>
          <el-input
            placeholder="请输入采购订单编码"
            type="number"
            clearable
            v-model.number="docEntry"
            size="mini"
          ></el-input>
        </div>
        <el-button
          type="primary"
          size="mini"
          :loading="isLoading"
          @click="handleSearch"
          >查询</el-button
        >
      </div>
      <div class="status-row">
        <div
          v-for="(status, index) in statusArr"
          :key="index"
          :class="{ 'is-active': activeStatus === status.value }"
          @click="toggleStatus(status)"
        >
          {{ status.label }}
        </div>
      </div>
      <div class="order-property-wrapper">
        <ul class="order-property">
          <li class="name">物料名称</li>
          <li class="code">物料编码</li>
          <li class="quality">品项</li>
          <li class="brand">品牌</li>
          <li class="model">机型</li>
          <li class="module">模块</li>
          <li class="quantity">采购数量</li>
          <li class="price">单价</li>
        </ul>
        <div class="operation">操作</div>
      </div>
    </div>
    <div
      class="order-list-wrapper"
      v-loading="isLoading"
      v-if="purchaseList.length > 0"
    >
      <div
        class="item-wrapper"
        v-for="(item, index) in purchaseList"
        :key="index"
      >
        <div class="item-header">
          <div class="header-left">
            <span class="time">{{ item.docDueDate | date }}</span>
            <span>采购订单：{{ item.docEntry }}</span>
          </div>
          <div class="status">状态：{{ item.state | purchaseStatus }}</div>
        </div>
        <div class="item-content">
          <div class="order-list">
            <div
              class="order-item"
              v-for="(item1, index1) in item.sapPurchaseOrderDetails"
              :key="index1"
            >
              <div class="name">{{ item1.itemName }}</div>
              <div class="code">{{ item1.itemCode }}</div>
              <div class="quality">
                <el-tag :type="item1.itemQualityName | qualityType" size="mini">
                  {{ item1.itemQualityName }}
                </el-tag>
              </div>
              <div class="brand">{{ item1.brand }}</div>
              <div class="model">{{ item1.machine }}</div>
              <div class="module">{{ item1.module }}</div>
              <div class="quantity">{{ item1.quantity }}</div>
              <div class="price">{{ item1.price }}</div>
            </div>
          </div>
          <div class="operation" @click="viewDetail(item.docEntry)">
            查看
          </div>
        </div>
      </div>
    </div>
    <div class="blank-replace" v-else>
      暂无数据
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      material: '',
      docEntry: '',
      statusArr: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待收货',
          value: 'Created'
        },
        {
          label: '处理中',
          value: 'Processing'
        },
        {
          label: '已完成',
          value: 'Completed'
        }
      ],
      activeStatus: '',
      purchaseList: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/purchase')
    this.$store.commit('setAsideWidth', 150)
  },
  created() {
    this.getPurchaseList()
  },
  methods: {
    getPurchaseList() {
      this.isLoading = true
      const params = {
        docEntry: this.docEntry,
        material: this.material,
        state: this.activeStatus,
        skipCount: (this.currentPage - 1) * this.pageSize,
        maxResultCount: this.pageSize
      }
      this.$http
        .get('/api/services/inquiryApp/purchaseOrder/GetSapAll', params)
        .then(res => {
          this.purchaseList = res.result.items
          this.total = res.result.totalCount
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    },
    handleSearch() {
      this.currentPage = 1
      this.getPurchaseList()
    },
    toggleStatus(status) {
      this.activeStatus = status.value
      this.getPurchaseList()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getPurchaseList()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.getPurchaseList()
    },
    viewDetail(id) {
      this.$router.push({
        path: '/purchase-detail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.purchase-container {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.purchase-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  height: 185px;
  width: 100%;
}
.search-row,
.material-name,
.purchase-order {
  display: flex;
  align-items: center;
  white-space: nowrap;
  span {
    margin-right: 15px;
    color: #2f343c;
  }
  .el-input {
    width: 200px;
  }
}
.search-row {
  margin-top: 15px;
}
.material-name,
.purchase-order {
  margin-right: 30px;
}

.status-row {
  height: 35px;
  display: flex;
  position: relative;
  margin-top: 15px;
  .is-active {
    border: 1px solid #027cff;
    color: #027cff;
    z-index: 5;
  }
  > div {
    height: 35px;
    padding: 0 10px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #b7bbc8;
    position: absolute;
    color: #2f343c;
    user-select: none;
    &:hover {
      border: 1px solid #027cff;
      color: #027cff;
      z-index: 5;
      cursor: pointer;
    }
    &:first-child {
      border-radius: 3px 0 0 3px;
      left: 0;
    }
    &:nth-child(2) {
      left: 49px;
    }
    &:nth-child(3) {
      left: 112px;
    }
    &:nth-child(4) {
      left: 175px;
      border-radius: 0 3px 3px 0;
    }
  }
}
.order-property-wrapper {
  width: 100%;
  height: 45px;
  margin-top: 15px;
  padding: 0 40px 0 20px;
  border-bottom: 1px solid #ededed;
  background-color: #f5f5f5;
  font-size: 14px;
  font-weight: 600;
  color: #2f343c;
  display: flex;
  align-items: center;
  .order-property {
    width: 90%;
    display: flex;
    align-items: center;
  }
  .operation {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.order-list-wrapper {
  width: 100%;
  // height: 1000px;
  height: calc(100% - 250px);
  background-color: #ffffff;
  overflow: auto;
  margin-top: 10px;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  font-size: 12px;
}
.item-wrapper {
  margin-top: 10px;
  border: 1px solid #ededed;
  &:first-child {
    margin-top: 0;
  }
  .item-header {
    height: 35px;
    padding: 0 20px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      height: 35px;
      display: flex;
      align-items: center;
      .time {
        margin-right: 30px;
      }
    }
  }
  .item-content {
    min-height: 45px;
    display: flex;
    padding: 0 20px;
    .order-list {
      width: 90%;
    }
    .operation {
      width: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #027cff;
      cursor: pointer;
    }
  }
  .order-item {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
  }
}
.blank-replace {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
  border-bottom: 1px solid #ebeef5;
}
.name {
  width: 30%;
}
.code {
  width: 10%;
}
.quality {
  width: 10%;
  display: flex;
  align-items: center;
}
.brand {
  width: 5%;
}
.model {
  width: 10%;
}
.module {
  width: 10%;
}
.quantity {
  width: 10%;
}
.price {
  width: 5%;
}
.operation {
  width: 10%;
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
